<template>
  <h4
    class="tw:scroll-m-20 tw:text-xl tw:text-primary tw:font-semibold tw:text-center tw:tracking-tight"
  >
    <slot />
  </h4>
</template>

<script setup>
</script>
